import { render } from "./Heading2.vue?vue&type=template&id=05218135&ts=true"
import script from "./Heading2.vue?vue&type=script&lang=ts"
export * from "./Heading2.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__